import DatabaseModel from './DatabaseModel.js';
import CacheService from './Cache.js';

var Servicio = Object.create(DatabaseModel);

Servicio.model = 'servicio';
Servicio.modelFront = 'servicios';

Servicio.clonar = function(params){
    var self = this;
    params = params || {};
    var params = {
        url: self.server_movilidad + self.prefix + self.model + '/copiar/' + params.itemId,
        method: 'GET',
        data: params.data
    };
    return self.sendRequest(params, false).then(function(res) {
        CacheService.clearCache(self.model);
        return res;
    });
}

export default Servicio;